<template lang='pug'>
.container-fluid.p-0.push-wrapper
  .container
    .row
      .col
        .row
          .col-12.my-header.font-weight-bold
            | Смена пароля
  .container.mt-5
    .white_block
      .row
        .col
          select(v-model="user_id")
            option(v-for="user of users", :value="user.id") {{ user.id }} | {{ user.name }} - {{ user.email }}
      .row
        .col 
          input(
            type="password",
            placeholder="Новый пароль",
            v-model="password"
          )
          br
          br
          button.styled(:disabled="loading", @click="ChangePassword") Обновить
</template>
<script>
import moment from "moment";
import apiDriver from "../../apiDriver";

export default {
  components: {},

  data() {
    return {
      users: [],
      password: "",
      user_id: -1,
      loading: false,
    };
  },

  computed: {},

  mounted() {
    this.loadUsers();
  },

  methods: {
    async loadUsers() {
      let users = (await apiDriver.admin.users.list()).users;
      for (let u of users) u.created = moment(u.createdAt).format("DD.MM.YYYY");
      this.users = users;
      if (this.$route.query.user_id) {
        this.user_id = this.$route.query.user_id;
      }
    },
    async ChangePassword() {
      if (this.user_id == -1) {
        this.$toast.error("Укажите пользователя!");
        return;
      }
      if (this.password.lenght == 0) {
        this.$toast.error("Укажите пароль!");
        return;
      }
      this.loading = true;
      let add = await apiDriver.admin.users.changePassword(
        this.user_id,
        this.password
      );
      this.loading = false;
      this.user_id = -1;
      this.$toast.success("Пароль обновлен!");
    },
  },
};
</script>
<style scoped lang="stylus">
div {
  cursor: default;
}

.my-header {
  font-size: 26pt;
}

.header-pre-push {
  font-size: 1.5rem;
}

.header-push {
  font-size: 1.5rem;
  color: black;
}

.main_amount {
  font-size: 26pt;
}

.user {
  &.red {
    .white_block {
      border-left: 2px solid red;
    }
  }

  .id {
    font-size: 10pt;
    color: gray;
  }

  .name {
    font-size: 16pt;
    display: inline-block;
  }

  .email {
    display: inline-block;
    margin-left: 10px;
    color: gray;
    position: relative;
    top: -2px;
  }

  .franchised_sum {
    position: absolute;
    top: 10px;
    right: 30px;
    background: #4CAF50;
    padding: 5px 10px;
    font-size: 10pt;
    border-radius: 5px;
    color: white;
  }

  .user_balances {
    border-left: 2px solid #eee;
    padding-left: 10px;
    margin: 10px 0;

    .real {
      display: inline-block;
    }

    .bonus {
      display: inline-block;
      margin-left: 10px;
      color: gray;
    }
  }
}
</style>
